module.exports = __webpack_public_path__ + "img/back.75eec17c.svg";